
import React from 'react';
import { cn } from '@/lib/utils';

interface TrackItemProps {
  track: {
    id: string;
    spotify_url?: string;
    artist_name?: string;
    track_title?: string;
    created_at: string;
  };
  prefix?: string;
  index?: number;
  className?: string;
}

const TrackItem: React.FC<TrackItemProps> = ({ 
  track, 
  prefix = "", 
  index = 0,
  className 
}) => {
  // Extract Spotify track ID from URL
  const getSpotifyTrackId = (url?: string): string | null => {
    if (!url) return null;
    
    const patterns = [
      /spotify:track:([a-zA-Z0-9]+)/,  // spotify:track:1234567890
      /open.spotify.com\/track\/([a-zA-Z0-9]+)/, // https://open.spotify.com/track/1234567890
      /\/track\/([a-zA-Z0-9]+)/,  // /track/1234567890
    ];
  
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    return null;
  };
  
  const trackId = getSpotifyTrackId(track.spotify_url);
  
  if (!trackId) {
    return null;
  }

  return (
    <div 
      className={cn(
        "mx-2 w-[280px] sm:w-[300px]",
        className
      )}
      data-item-index={index}
    >
      <iframe 
        src={`https://open.spotify.com/embed/track/${trackId}?utm_source=generator`}
        width="100%" 
        height="352" 
        frameBorder="0" 
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
        loading="lazy"
        className="w-full rounded-md"
      />
    </div>
  );
};

export default TrackItem;
